import { Tag, Space, Button, Tooltip } from 'antd';
import { EditOutlined, PrinterOutlined } from '@ant-design/icons';
import { displayMessage } from '../../../helpers/messages';
import { formatDateBR, formatTime } from '../../../helpers/date';

export const batchGridColumns = (handleEdit, handlePrint) => [
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
    width: 80,
    sorter: (a, b) => a.id - b.id,
  },
  // {
  //   title: 'Cor',
  //   dataIndex: ['client', 'color'],
  //   key: 'client_color',
  //   width: 60,
  //   render: (_, record) => (
  //     <div
  //       style={{
  //         width: 30,
  //         height: 30,
  //         backgroundColor: record.client?.color || '#1890ff',
  //         borderRadius: '50%',
  //         border: '2px solid #d9d9d9',
  //         margin: '0 auto',
  //       }}
  //       title={record.client?.color || '#1890ff'}
  //     />
  //   ),
  // },
  {
    title: 'Identificador',
    key: 'batch_identifier',
    width: 160,
    render: (_, record) => {
      if (!record.client?.nickname || !record.date) return 'N/A';
      
      // Formatar data no formato DDMMAA
      const date = new Date(record.date);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = String(date.getFullYear()).slice(-2);
      const dateFormatted = `${day}${month}${year}`;
      
      const identifier = `${record.client.nickname.toUpperCase()}-${dateFormatted}`;
      
      return (
        <Tag 
          color={record.client?.color || '#1890ff'}
          style={{ 
            fontSize: '13px', 
            fontWeight: 'bold',
            padding: '4px 8px'
          }}
        >
          {identifier}
        </Tag>
      );
    },
    sorter: (a, b) => {
      const identifierA = a.client?.nickname ? `${a.client.nickname}-${a.date}` : '';
      const identifierB = b.client?.nickname ? `${b.client.nickname}-${b.date}` : '';
      return identifierA.localeCompare(identifierB);
    },
  },
  {
    title: displayMessage('CLIENT'),
    dataIndex: ['client', 'company_name'],
    key: 'client',
    sorter: (a, b) => (a.client?.company_name || '').localeCompare(b.client?.company_name || ''),
  },
  {
    title: 'Data e Hora',
    key: 'date_time',
    width: 160,
    render: (_, record) => {
      const dateFormatted = record.date ? formatDateBR(record.date) : '';
      const timeFormatted = record.time ? formatTime(record.time) : '';
      
      if (!dateFormatted && !timeFormatted) {
        return <span style={{ color: '#999' }}>-</span>;
      }
      
      if (dateFormatted && timeFormatted) {
        return `${dateFormatted} ${timeFormatted}`;
      }
      
      return dateFormatted || timeFormatted;
    },
    sorter: (a, b) => {
      // Ordena primeiro por data, depois por hora
      const dateCompare = new Date(a.date) - new Date(b.date);
      if (dateCompare !== 0) return dateCompare;
      return (a.time || '').localeCompare(b.time || '');
    },
  },
  {
    title: displayMessage('INVOICE_NUMBER'),
    dataIndex: 'invoice_number',
    key: 'invoice_number',
    width: 150,
    sorter: (a, b) => (a.invoice_number || '').localeCompare(b.invoice_number || ''),
  },
  {
    title: displayMessage('DRUM_QUANTITY'),
    dataIndex: 'drum_quantity',
    key: 'drum_quantity',
    width: 100,
    sorter: (a, b) => a.drum_quantity - b.drum_quantity,
  },
  {
    title: displayMessage('OBSERVATION'),
    dataIndex: 'observation',
    key: 'observation',
    width: 200,
    render: (observation) => {
      if (!observation || observation.trim() === '') {
        return <span style={{ color: '#999' }}>-</span>;
      }
      
      // Truncar texto para exibição
      const truncatedText = observation.length > 50 
        ? `${observation.substring(0, 50)}...` 
        : observation;
      
      return (
        <Tooltip title={observation} placement="topLeft">
          <span style={{ cursor: 'help' }}>{truncatedText}</span>
        </Tooltip>
      );
    },
    sorter: (a, b) => (a.observation || '').localeCompare(b.observation || ''),
  },
  {
    title: displayMessage('CREATED_BY'),
    dataIndex: ['user', 'first_name'],
    key: 'user',
    render: (_, record) => {
      if (record.user) {
        return `${record.user.first_name} ${record.user.last_name}`;
      }
      return 'N/A';
    },
    sorter: (a, b) => (a.user?.first_name || '').localeCompare(b.user?.first_name || ''),
  },
  
  {
    title: displayMessage('ACTIONS'),
    key: 'actions',
    width: 150,
    fixed: 'right',
    render: (_, record) => (
      <Space size="small">
        <Tooltip title="Editar lote">
          <Button
            type="primary"
            icon={<EditOutlined />}
            size="small"
            onClick={() => handleEdit(record)}
          >
            {/* {displayMessage('EDIT')} */}
          </Button>
        </Tooltip>
        
        <Tooltip title="Imprimir etiquetas">
          <Button
            type="default"
            icon={<PrinterOutlined />}
            size="small"
            onClick={() => handlePrint(record)}
          >
            {/* Imprimir */}
          </Button>
        </Tooltip>
      </Space>
    ),
  },
];

